import { useQuery } from '@tanstack/react-query'

import { quickSortOn } from '@/src/general/utils/quickSortOn'

import { tagsQueryOptions } from './useTagsQuery'

export const useThemeTagsQuery = (options?: { enabled?: boolean }) =>
  useQuery({
    ...tagsQueryOptions,
    enabled: options?.enabled,
    select: (data) =>
      data
        .filter(
          (tag) =>
            tag.wizardPage === 1 &&
            (!tag.periods ||
              tag.periods.find((period) => {
                const date = new Date()
                return date >= new Date(period[0]) && date <= new Date(period[1])
              })),
        )
        .sort(quickSortOn('wizardOrder')),
  })
